import CategoriesBrowser from 'components/admin/Categories/CategoriesBrowser.jsx'
import CategoryDetail from 'components/admin/Categories/CategoryDetail'
import NewCategoryModal from 'components/admin/Categories/NewCategoryModal'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  loadPathLeaves,
  loadPaths,
  loadProductCategories,
} from 'redux/categories'
import { cancelConfirm } from 'redux/navigation'
import { loadProducts } from 'redux/product'
import { loadProperties } from 'redux/properties'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = undefined

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadProperties,
      loadPathLeaves,
      loadProducts,
      loadProductCategories,
      loadPaths,
    },
    dispatch
  )
}

class ProductCategoriesContainer extends React.PureComponent {
  componentWillMount() {
    const {
      loadPathLeaves,
      loadProperties,
      loadProducts,
      loadProductCategories,
      loadPaths,
    } = this.props
    loadProductCategories()
    loadPathLeaves()
    loadPaths()
    loadProperties()
    loadProducts()
  }

  render() {
    return (
      <Grid stackable>
        <NewCategoryModal />
        <Grid.Row columns={2}>
          <Grid.Column
            tablet={12}
            computer={3}
            largeScreen={3}
            widescreen={3}
            className="stacked top up-to-largeScreen">
            <CategoriesBrowser />
          </Grid.Column>
          <Grid.Column
            tablet={12}
            computer={9}
            largeScreen={9}
            widescreen={9}
            className="stacked">
            <CategoryDetail />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductCategoriesContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProductCategoriesContainer
)
export default ProductCategoriesContainer



// WEBPACK FOOTER //
// ./src/containers/admin/product_categories.jsx